/**
 * Copyright © 2026 Delicious AI, LLC
 */

import { gql } from '@apollo/client'

export const NEXT_IMAGE_FOR_DETECTION = gql`
  query NextImageForDetection {
    nextImageForDetection {
      __typename
      ... on ImagePointer {
        imageId
      }
      ... on NoItemsAvailableError {
        code
        message
      }
      ... on LeaseLockError {
        code
        message
        retryAfterMs
      }
    }
  }
`
